import React, { useCallback, useEffect, useMemo } from 'react';
import * as Styled from './WebPlayerTimer.styled';
import { useStopwatchTimer } from '../../../utility/TimerHooks';
import { useSelector, useDispatch } from 'react-redux';
import {
  promptDiagnosis,
  selectChatState,
  ChatStates,
  completeSession,
} from '../../../slices/chat/ChatSlice';
import SessionTime from '../../atoms/SessionTime/SessionTime';
import { virtualHumanDataSelector } from '../../../slices/VirtualHumanSlice';
import { usePrevious } from '../../../../../../utility/CustomHooks';
import { patientSelector } from '../../../slices/PatientSlice';
import { useVHTypeConfig } from '../../vh-types/vhTypeHooks';
import { GetFormattedTime } from '../../../../../../utility/TimeFormatting';

export const ClockIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.653"
    height="20.653"
    viewBox="0 0 20.653 20.653"
    fill="#111b32"
  >
    <defs></defs>
    <g transform="translate(-381.683 -3698.421)">
      <g transform="translate(381.683 3698.421)">
        <path
          class="a"
          d="M133.421,98.581l3.427-2.491a.505.505,0,0,0,.208-.409V88.943a.509.509,0,0,0-.507-.507h-.591a.509.509,0,0,0-.507.507v6.175l-2.976,2.166a.506.506,0,0,0-.11.709l.347.477A.51.51,0,0,0,133.421,98.581Z"
          transform="translate(-125.555 -83.552)"
        />
        <path
          class="a"
          d="M139.245,86a10.326,10.326,0,1,1-10.327,10.325A10.323,10.323,0,0,1,139.245,86Zm0,18.779a8.453,8.453,0,1,0-8.45-8.454A8.442,8.442,0,0,0,139.245,104.778Z"
          transform="translate(-128.918 -85.999)"
        />
      </g>
    </g>
  </svg>
);

const WebPlayerTimer = (props) => {
  const startTime = useSelector((state) => state.chat.startTime);
  const dispatch = useDispatch();
  const chatState = useSelector(selectChatState);
  const vh = useSelector(virtualHumanDataSelector);
  const vhTypeConfig = useVHTypeConfig();
  const { TimeLimit } = vh;
  const vhDBVH = useSelector(patientSelector);

  const stopwatchCallback = useCallback(() => {
    vhTypeConfig.onFinishSession(dispatch, vhDBVH);
  }, [dispatch, vhDBVH, vhTypeConfig]);

  const [timerState, startTimer, stopTimer] = useStopwatchTimer(
    startTime,
    TimeLimit * 60,
    stopwatchCallback
  );

  const initialTime = useMemo(
    () => GetFormattedTime(TimeLimit * 60 * 1000),
    [TimeLimit]
  );

  const prevChatState = usePrevious(chatState);

  useEffect(() => {
    if (
      !timerState.running &&
      !timerState.finished &&
      chatState === ChatStates.TALK &&
      TimeLimit > 0
    ) {
      startTimer();
    }
  }, [
    startTimer,
    timerState.running,
    timerState.finished,
    chatState,
    TimeLimit,
  ]);

  useEffect(() => {
    // stop timer when no longer in talk state
    if (prevChatState === ChatStates.TALK && chatState !== ChatStates.TALK) {
      stopTimer();
    }
  }, [chatState, stopTimer, prevChatState]);

  if (chatState === ChatStates.LOADING || TimeLimit === 0) {
    return <></>;
  }
  return (
    <Styled.Wrapper>
      <Styled.TimeWrapper>
        {ClockIcon}
        <SessionTime>
          {chatState === ChatStates.AWAITING_FIRST_CHAT
            ? initialTime
            : timerState.formattedTimeRemaining}
        </SessionTime>
      </Styled.TimeWrapper>
    </Styled.Wrapper>
  );
};

WebPlayerTimer.propTypes = {};

export default WebPlayerTimer;
